export const SET_CLIENT = "SET_CLIENT";
export const ADD_MESSAGE = "ADD_MESSAGE";